export const getcartInfo = (params) => ({
    type: 'GET_CART_INFO',
    params,
});


export const setCartFmonthPrice = (data) => ({
    type: 'SET_CART_FMONTH_PRICE',
    data
});
export const updateFloatingCart = (constructedJson) => ({
    type: 'UPDATE_FLOATING_CART',
    data: constructedJson
});

export const resetCartInfoResponse = () => ({
    type: "RESET_CART_INFO_RESPONSE",
})
export const resetCartFmonthPrice = () => ({
    type: "RESET_CART_FMONTH_PRICE",
})
